import history from "history/browser";
import qs from 'qs';
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';
import isPlainObject from 'lodash/isPlainObject';
import isObject from 'lodash/isObject';
import get from 'lodash/get';
import set from 'lodash/set';
import Hooks from './Hooks';

export { history };

export function startHistoryListener(callback) {
  history.listen(callback);
}

export function removeEmptyValuesFromObject(baseFilter) {
  const filter = cloneDeep(baseFilter);

  delete filter._persist;
  delete filter.bodyPart;

  Object.keys(filter).forEach((key) => {
    if (isPlainObject(filter[key])) {
      filter[key] = removeEmptyValuesFromObject(filter[key]);
    }

    if ((isEmpty(filter[key]) && isObject(filter[key])) || !filter[key]) {
      delete filter[key];
    }
  });

  return filter;
}

let prevFilter = null;

export function setPrevFilter(filter) {
  prevFilter = cloneDeep(filter);
}

function shortenQueryFilter(filter, bodyParts) {
  const newFilter = cloneDeep(filter);

  if (newFilter.params) {
    // remove body parts all values
    if (bodyParts) {
      bodyParts.forEach((bodyPart) => {
        if (newFilter.params[bodyPart] === 'all') {
          delete newFilter.params[bodyPart];
        }
      });
    }

    // rename params to p
    newFilter.p = newFilter.params;
    delete newFilter.params;
  }

  if (newFilter.bodyPart) {
    delete newFilter.bodyPart;
  }

  return newFilter;
}

export function unshortenQueryFilter(filter, bodyParts) {
  const newFilter = cloneDeep(filter);

  // rename p to params
  if (newFilter.p) {
    newFilter.params = newFilter.p;
    delete newFilter.p;
  }
  else if (!newFilter.params) {
    newFilter.params = {};
  }

  // fill in body parts all values
  if (bodyParts) {
    bodyParts.forEach((bodyPart) => {
      if (!newFilter.params[bodyPart]) {
        newFilter.params[bodyPart] = 'all';
      }
    });
  }

  return newFilter;
}

export function pushFilterToHistory(baseFilter, bodyParts) {
  let filter = removeEmptyValuesFromObject(cloneDeep(baseFilter));
  if (!isEqual(prevFilter, filter)) {
    filter = Hooks.call('history.filterBeforePush', filter);
    const shortenedFilter = shortenQueryFilter(filter, bodyParts);
    if (!isEmpty(shortenedFilter.p)) {
      shortenedFilter.p = JSON.stringify(shortenedFilter.p);
    }
    const queryString = qs.stringify(shortenedFilter, {
      encodeValuesOnly: true,
      arrayFormat: 'comma',
      allowDots: true,
      skipNulls: true,
    });
    setPrevFilter(filter);
    history.replace(`${window.location.pathname}?${queryString}`);
  }
}

const URL_LIST_PARAMS = [
  'params.subcategory',
  'params.brands',
  'params.color',
  'params.design',
  'params.materialText',
  'params.vibe',
  'occasion',
  'cfo',
  'params.size',
  'params.discount',
  'params.shippingOption',
  'params.newArrivals',
  'params.wash',
];

const NUMBER_PARAMS = [
  'offset',
  'limit',
];

export function parseUrlState(categories) {
  let shortenedFilter = Hooks.call('history.parseUrlState', qs.parse(window.location.search, {
    ignoreQueryPrefix: true,
    allowDots: true,
    comma: true,
    interpretNumericEntities: true,
  }));
  if (typeof shortenedFilter.p === 'string') {
    shortenedFilter.p = JSON.parse(shortenedFilter.p);
  }
  const partList = categories[shortenedFilter.categoryId]?.partList;
  const filter = unshortenQueryFilter(shortenedFilter, partList);

  URL_LIST_PARAMS.forEach(path => {
    const param = get(filter, path);
    if (param && typeof param === 'string') {
      set(filter, path, param.split(','));
    }
  });

  NUMBER_PARAMS.forEach(path => {
    const param = get(filter, path);
    if (param && typeof param === 'string') {
      set(filter, path, parseInt(param, 10));
    }
  });

  if (filter.params['price'] && /^[0-9.]*-[0-9.]*$/.test(filter.params['price'])) {
    let priceText = filter.params['price'];
    if (priceText.indexOf('-') === 0) {
      priceText = priceText.replace('-', '0-');
    }
    const prices = priceText.split('-');
    const from = parseInt(prices[0], 10);
    const to = parseInt(prices[1], 10);
    
    filter.params['price'] = `${!isNaN(from) && from && from >= 0 ? from : ''}-${!isNaN(to) && to && to > 0 ? to : ''}`;
  }
  else {
    delete filter.params['price'];
  }

  if (Array.isArray(filter.categoryId)) {
    filter.categoryId = filter.categoryId.join(',');
  }

  return filter;
}
